import { orchestrator } from 'satcheljs';
import { setSafeLinksSettingService } from '../services/setSafeLinksSetting';
import { setSafeLinksSettingAction } from '../actions/setSafeLinksSetting';
import setSafeLinksOption from '../mutators/setSafeLinksSetting';

export default orchestrator(setSafeLinksSettingAction, async actionMessage => {
    await setSafeLinksSettingService(actionMessage.isSafeLinksEnabled);
    setSafeLinksOption(actionMessage.isSafeLinksEnabled);
});
